// extracted by mini-css-extract-plugin
export var closeButton = "_v-1";
export var container = "_v-0";
export var fullModalImage = "_v-2";